import orders from '../mock-data/orders.json';
import customers from '../mock-data/customers.json';
import invoices from '../mock-data/invoices.json';
import type { RoseRocketClient } from './roseRocketClient.interface';
import type { RoseRocketCustomer, RoseRocketInvoice, RoseRocketOrder } from '../types/entities';

function filterUpdated<T extends { updated_at: string }>(records: T[], updatedSince?: string): T[] {
  if (!updatedSince) return records;
  const cutoff = Date.parse(updatedSince);
  if (Number.isNaN(cutoff)) throw new Error(`Invalid SYNC_UPDATED_SINCE timestamp: ${updatedSince}`);
  return records.filter((record) => Date.parse(record.updated_at) >= cutoff);
}

export class RoseRocketMockClient implements RoseRocketClient {
  async getOrders(updatedSince?: string): Promise<RoseRocketOrder[]> {
    return filterUpdated(orders as RoseRocketOrder[], updatedSince);
  }

  async getCustomers(updatedSince?: string): Promise<RoseRocketCustomer[]> {
    return filterUpdated(customers as RoseRocketCustomer[], updatedSince);
  }

  async getInvoices(updatedSince?: string): Promise<RoseRocketInvoice[]> {
    return filterUpdated(invoices as RoseRocketInvoice[], updatedSince);
  }
}
